(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["twpc-2027-landing"] && !Shopify.designMode) return;
  try {
    
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const observers = new Map();
  const revealAll = () => {
    observers.forEach(observer => observer.disconnect());
    observers.clear();
    document.querySelectorAll('.twpc27 .reveal-ready').forEach(element => element.classList.add('is-visible'));
  };
  const initialize = scope => {
    const roots = scope.matches?.('.twpc27') ? [scope] : scope.querySelectorAll('.twpc27');
    roots.forEach(root => {
      if (observers.has(root) || reduceMotion.matches || !('IntersectionObserver' in window) || window.Shopify?.designMode) return;
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.08, rootMargin: '0px 0px -32px 0px' });
      observers.set(root, observer);
      const elements = root.querySelectorAll('.section > .wrap:not(.split) > .label, .section > .wrap:not(.split) > h2, .section > .wrap:not(.split) > .intro, .section > .wrap > .actions, .split > div, .card, .step, .ticket, .venue-box, .quote p');
      elements.forEach(element => {
        const isCard = element.matches('.card, .step, .ticket, .venue-box');
        const index = isCard ? Array.from(element.parentElement.children).indexOf(element) : 0;
        element.style.setProperty('--reveal-delay', Math.min(index * 80, 240) + 'ms');
        if (element.getBoundingClientRect().top < window.innerHeight - 32) {
          element.classList.add('is-visible');
        }
        element.classList.add('reveal-ready');
        observer.observe(element);
      });
      root.addEventListener('focusin', event => {
        event.target.closest('.reveal-ready')?.classList.add('is-visible');
      });
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('.twpc27').forEach(root => {
      observers.get(root)?.disconnect();
      observers.delete(root);
    });
  });
  reduceMotion.addEventListener('change', () => {
    if (reduceMotion.matches) revealAll();
    else initialize(document);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
